import React, { useState, useEffect } from 'react'

import { Tab, Row, Button } from 'components'
import { useLoading, useFile, useModal, useException } from 'hooks'
import { RegisterPendingServices } from 'services/GST/CadastroItensSubitensSeguranca'
import { ManuaisFornecedorService } from 'services/Generic/Generic'
import { TipoPendencia } from 'utils/types'
import { SPACING } from 'utils'

import { MonthlyDocumentation, Pendency, Search } from './components'
import { ThirdPartyAdministrationProvider } from './context/provider'

export const ThirdParty: React.FC = () => {
  const { setLoading, setMsgErro } = useLoading()
  const { downloadFile } = useFile()
  const { createCustomException, getException } = useException()
  const { showModal } = useModal()
  const tabs = ['Pesquisar', 'Documentação Mensal', 'Pendência']

  const [selectedTab, setSelectedTab] = useState<number>(0)
  const [documentTypes, setDocumentTypes] = useState<TipoPendencia[]>([])

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  const getDocTypes = () => {
    setLoading('loading')

    RegisterPendingServices()
      .getAll({isTelaCRE:true})
      .then((response) => {
        if (response.status === 200) {
          // response.data.unshift({
          //   idTipoPendencia: 0,
          //   txDescricao: '',
          //   txTipo: ''
          // })
          setDocumentTypes(response.data as TipoPendencia[])
        }

        setLoading('idle')
      })
      .catch(() => {
        // setLoading('error')
        // setMsgErro('Não foi possível obter os tipos de documento')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os tipos de documento',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleDownloadOrientacao = () => {
    setLoading('loading')

    ManuaisFornecedorService()
      .getManual('Orientacao-Geral-Documentacao-Mensal.pdf')
      .then(response => {
        if (response.status !== 200) {
          createCustomException({
            message: 'Não foi possível fazer o download do manual',
          })
        }

        downloadFile({
          local: { filename: 'Orientação-Geral-Documentação-Mensal.pdf', base64: response.data }
        })
      })
      .catch((error: Error) => {
        const { message } = getException(error)
        showModal({
          type: 'error',
          message: message || 'Houve um erro ao efetuar o download do manual',
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
      .finally(() => setLoading('idle'))
  }

  useEffect(() => {
    getDocTypes()
  }, [])

  return (
    <ThirdPartyAdministrationProvider>
      <Row
        marginTop={SPACING.spacing10}
        justifyContent="flex-end"
      >
        <Button
          text="Orientações Gerais de Documentação para Análise"
          variantButton="outlined"
          onClick={handleDownloadOrientacao}
          marginRight={SPACING.spacing20}
        />
      </Row>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 &&
        <Search
          documentTypes={documentTypes}
        />
      }
      {selectedTab === 1 && <MonthlyDocumentation />}
      {selectedTab === 2 && <Pendency />}
    </ThirdPartyAdministrationProvider>
  )
}
